import React from "react";

const SvgO = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="O_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#O_svg__a)">
      <path
        d="M143.44 160.93a16.58 16.58 0 0 1 8.53 2.28 17.063 17.063 0 0 1 6.16 6.14 17.092 17.092 0 0 1 0 17 16.986 16.986 0 0 1-6.16 6.16 17.092 17.092 0 0 1-17 0 17 17 0 0 1-6.14-6.16 16.575 16.575 0 0 1-2.28-8.54 17 17 0 0 1 5-12 16.573 16.573 0 0 1 5.47-3.64 16.918 16.918 0 0 1 6.42-1.24zm0 2.64a14.144 14.144 0 0 0-7.14 1.89 13.863 13.863 0 0 0-5.23 5.25c-3.955 6.846-1.614 15.602 5.23 19.56a14.31 14.31 0 0 0 21.48-12.42 14.177 14.177 0 0 0-1.92-7.14 13.863 13.863 0 0 0-5.23-5.25 14.236 14.236 0 0 0-7.19-1.9v.01z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgO;